(() => {
  const videos = document.querySelectorAll('video.tw-deferred-video');

  if (!videos.length) return;

  videos.forEach((video) => {
    video.querySelectorAll('img:not([alt])').forEach((image) => image.setAttribute('alt', ''));
  });

  const loadAndPlay = (video) => {
    video.preload = 'metadata';
    video.load();
    video.play().catch(() => {});
  };

  if (!('IntersectionObserver' in window)) {
    videos.forEach(loadAndPlay);
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        loadAndPlay(entry.target);
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '300px 0px' }
  );

  videos.forEach((video) => observer.observe(video));
})();
